import type { PayloadError } from "relay-runtime";

/** A GraphQL mutation that answered with `errors`; `message` is the first error's message. */
export class AsyncMutationError extends Error {
	constructor(
		public readonly errors: readonly PayloadError[],
		/** The `data` of the GraphQL response, when the server returned any. */
		public readonly data?: unknown
	) {
		super(errors[0]?.message ?? "GraphQL mutation failed");
		this.name = "AsyncMutationError";
	}
}

/**
 * Turns a GraphQL response with `errors` into an `Error`, so callers can show
 * `error.message` and still read `error.errors` (including `extensions`).
 */
export function mutationResponseError(response: { errors?: readonly PayloadError[] | null; data?: unknown }): AsyncMutationError {
	return new AsyncMutationError(Array.isArray(response.errors) ? response.errors : [], response.data);
}
